<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Pasavantes</h4>
            <p>Realiza la emision de Pasavantes Provisionales y Solicitudes Formales a naves con Pasavantes</p>       
        </div>
        <h6 clas="col" align="center">UFV {{ ufv }} al {{ date_ufv }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button> </h6>
    </div>
    
    <div class="form-row">
        <div class="form-group col offset-md-3 col-md-6">
            <label for="captain_download" class="badge badge-info">CAPITANIA</label>
            <transition name="fade" mode="out-in">
            <select v-if="dRolUser" name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
            </select>
            <div v-else class="alert alert-success">
                {{ cSessionUser.name_port }}
            </div>
            </transition>
        </div>
    </div>

    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#emit_pasavant" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Emision de Pasavante</a>
            <a class="nav-item nav-link" id="nav-capitan-list" data-toggle="tab" href="#formalize_pasavant" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Pasar a Solicitud Formal</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="emit_pasavant" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Embarcacion/Nave/Artefacto Naval Pasavante</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="ship_select.id > 0" class="panel panel-default">

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Embarcación</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="ship_select.name_boat">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Matricula </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.enrollment_old" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">TRB </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.trb" name="number_identification" readonly>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-3">
                                <label for="type_identification" class="badge badge-primary">Fecha de Inicio Actividades</label>
                                <input type="date" name="date_init_pasavante" id="date_init_pasavante" class="form-control" autocomplete="off" v-model="pasavant_data.date_init_aux">
                            </div>

                            <div class="form-group col-12 col-md-3">
                                <label for="type_identification" class="badge badge-primary">Fecha de Conclusión Actividades</label>
                                <input type="date" name="date_end_pasavante" id="date_end_pasavante" class="form-control" autocomplete="off" v-model="pasavant_data.date_end_aux">
                            </div>

                            <div class="form-group col-12 col-md-2">
                                <label for="type_identification" class="badge badge-primary">Número Tripulantes</label>
                                <input type="number" min="0" placeholder="1" name="date_end_pasavante" id="date_end_pasavante" class="form-control" autocomplete="off" v-model="pasavant_data.number_person">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Matrícula (Si corresponde)</label>
                                <input type="text" min="0" placeholder="MATRICULA SI CORRESPONDE" name="date_end_pasavante" id="date_end_pasavante" class="form-control" autocomplete="off" v-model="pasavant_data.enrollment_temp">
                            </div>                            
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Oficio/Solicitud</label>
                                <input type="text" placeholder="OFICIO ST/DT/OF XXX" name="document_solicitud" id="document_solicitud" class="form-control" autocomplete="off" v-model="pasavant_data.number_office">
                            </div>
                            <div class="form-group col-12 col-md-6">
                                <label for="type_identification" class="badge badge-primary">Persona / Entidad Solicitante</label>
                                <input type="text" name="person_entity_solicitante" id="person_entity_solicitante" placeholder="MINISTERIO DE RELACIONES EXTERIORES" class="form-control" autocomplete="off" v-model="pasavant_data.person_responsability">
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="type_identification" class="badge badge-primary">Bandera</label>
                                <select name="flag_pasavante" id="flag_pasavante" class="form-control" v-model="pasavant_data.flag">
                                    <option v-for="lf of list_flag" :key="lf.id" :value="lf.id">{{lf.detail}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="site_expedition" class="badge badge-primary">Área Jurisdicción</label>
                                <textarea cols="30" rows="3" name="document_solicitud" placeholder="del Lago Titicaca" id="document_solicitud" class="form-control" autocomplete="off" v-model="pasavant_data.jurisdiccion"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Importe Bs.</label>
                                <input type="text" class="form-control-plaintext"  name="number_identification" readonly :value="ship_select.import">
                            </div>
                        </div>

                        <button class="btn btn-danger col-12 col-md-2 offset-md-4" @click="mCloseSelectShip"><font-awesome-icon icon="times-circle" size="2x" /></button>
                        <button class="btn btn-success col-12 col-md-2" @click="mSavePasavante"><font-awesome-icon icon="save" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip1" v-model="optionSearchShip"  value="enrollment" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip2" v-model="optionSearchShip" value="name">Matricula
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypeShip }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_ship" :placeholder="searchTypeShip" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeShip }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataShip">Buscar</button>

                        <div class="table-responsive" v-if="list_ship_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>MATRICULA</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(shipSelc, index) in list_ship_select" :key="shipSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ shipSelc.name_boat }}</span>
                                        </td>
                                        <td>{{ shipSelc.enrollment_old }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectShipOwner(shipSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="formalize_pasavant" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Embarcacion/Nave/Artefacto Naval a solicitud oficial</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <!-- busqueda de embarcacion y posterior seleccion a otro formulario-->
                    <div>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip1" v-model="optionSearchShip"  value="enrollment" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip2" v-model="optionSearchShip" value="name">Matricula
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypeShip }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_ship_oficial" :placeholder="searchTypeShip" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeShip }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataShipOficial">Buscar</button>

                        <div class="table-responsive" v-if="list_ship_oficial.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>MATRICULA</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(shipSelcpsv, index) in list_ship_oficial" :key="shipSelcpsv.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ shipSelcpsv.name_boat }}</span>
                                        </td>
                                        <td>{{ shipSelcpsv.enrollment_old }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectShipOwnerOficial(shipSelcpsv)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>

        <!-- end second tab -->

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';


export default {
    name:'pasavant-options',
    data(){
        return{
            dRolUser:0,
            description_transfer:null,
            owner:{},
            person_select:{id:0},
            list_person_select:[],
            ship_select:{id:0},
            list_ship_select:[],
            types_identification:[],
            citys:[],
            countrys:[],
            status_send:true,
            modal_load_id:'id_owner_new',
            modal_load_title:'Registrando', 
            optionSearchShip:'name',
            optionSearchPerson:'name',
            data_person:null,
            data_ship:null,
            data_ship_oficial:null,
            optionSearch:'name',
            old_owner:{id:0},
            dts_transfer:null,
            ufv:null,
            date_ufv:null,
            list_flag:[],
            pasavant_data:{
                date_init_aux:null,
                date_end_aux:null,
                flag:0,
                jurisdiccion:null,
                number_office:null,
                number_person:0,
                person_responsability:null,
                capitania:null,
                enrollment_temp:null
            },
            port_local:[],
            port_select:0,
            ship_select_oficial:{},
            list_ship_oficial:[],
            ship_pasavant_tmp:{},
            ship_pasavant_engine:{},
            ship_pasavant_owner:{}
        }
    },
    mounted(){
        this.callUfv();
        this.callFlag();
        this.getDay();
        this.getPorts();
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
    },
    methods:{
        aux_number(num){
            let num_aux=0;
            if(num<10){
                num_aux=`0${num}`;
            }else{
                num_aux=num;
            }
            return num_aux;
        },
        async getPorts(){
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.port_local=ports.data;
        },
        getDay(){
            this.dRolUser= this.cSessionUser.role !== 4 ? true:false;

            
            const nd= new Date();
            let aux_day=nd.getDate();
            aux_day=this.aux_number(aux_day);
            let aux_month = nd.getMonth()+1;
            aux_month=this.aux_number(aux_month);
            let aux_date=`${nd.getFullYear()}-${aux_month}-${aux_day}`;
            console.log(aux_date);
            this.pasavant_data.date_init_aux=aux_date;
            this.pasavant_data.date_end_aux=aux_date;
        },
        callFlag(){
            axios.get(`globals/flags?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                // console.log(res.data[0])
                this.list_flag=res.data;
                console.log(this.list_flag)
            })
        },
        callUfv(){
            // axios.get('ufv?api_token='+Vue.auth.getToken())
            // axios.get(`ufv`)
            this.dRolUser= this.cSessionUser.role === 3 ? true:false;
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                // console.log(res.data[0])
                this.ufv=res.data[0].value;
                this.date_ufv=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                // this.calculateForm();
                // this.mUpdateShips();
            })
        },
        mValidatePasavante(){
            if(this.pasavant_data.number_person <= 0){
                toastr.error('Indique el numero de tripulantes','Error');
                return false;
            }
            if(this.pasavant_data.number_office === null || this.pasavant_data.number_office === ''){
                toastr.error('Indique el oficio de solicitud','Error');
                return false;
            }
            if(this.pasavant_data.person_responsability === null || this.pasavant_data.person_responsability === ''){
                toastr.error('Indique el responsable u solicitante','Error');
                return false;
            }
            if(this.pasavant_data.flag === 0  ){
                toastr.error('Indique la bandera de la embarcacion','Error');
                return false;
            }
            if(this.pasavant_data.jurisdiccion === null || this.pasavant_data.jurisdiccion === '' ){
                toastr.error('Indique la jurisdiccion de trabajo a desempeñar','Error');
                return false;
            }
            let aux_port=this.cSessionUser.role !== 4 ? this.port_select:this.cSessionUser.portId;
            if(aux_port === 0 ){
                toastr.error('Seleccione una capitania','Error');
                return false;
            }
            return true;
        },
        async mSavePasavante(){
            if(this.mValidatePasavante()){
                
                let message = {
                title: 'Registrar Pasavante',
                body: `¿Desea registrar el Pasavante para la Nave/Artefacto Naval <b>${this.ship_select.name_boat}</b> por un importe de <b>${this.ship_select.import} Bs.</b> ?`
            };
            // validar que los datos esten completos
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });
                
            npr.then(async (msg)=>{
                    if(msg){
                        console.log('enviado despues de la pregunta');
                        // registramos el pasavante
                        this.pasavant_data.capitania=this.cSessionUser.role !== 4 ? this.port_select.id:this.cSessionUser.portId;
                        // console.log(this.ship_select);
                        // console.log(this.pasavant_data);

                        try {
                            let dts_new_pasavant={
                                ship:JSON.stringify(this.ship_select),
                                pasavant:JSON.stringify(this.pasavant_data)
                            }
                            console.log(dts_new_pasavant);
                            // this.dts_ordop.detail_organization=JSON.stringify(this.person_selecteds_ordop);
                            this.btn_u_newp = true;
                            // this.activeModal(this.id_modal_progress);
                            let dts_reg_pasavante=await axios.post(`insertPasavant?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_new_pasavant));

                            setTimeout(()=>{        
                                console.log(dts_reg_pasavante);                        
                                if(dts_reg_pasavante.data.status){
                                    toastr.success(dts_reg_pasavante.data.respuesta);
                                    this.mCloseSelectShip();
                                }
                                
                                // this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                // this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo el pasavante')
                        // console.log(this.dts_ordop);
                    }
                })

                // console.log(this.date_init_aux);
                // console.log(this.date_end_aux);
                // console.log(this.ship_select);
                // console.log(this.pasavant_data);
    
                // console.log('enviando el pasavante');
            }
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
        mValidateDescriptionChange(){
            try {
                let auxDescription=this.description_transfer.trim();
                if(this.description_transfer===null || auxDescription.length===0){
                    toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01');
                    return false;
                }
                return true;    
            } catch (error) {
                console.log('error ')
            }
            
        },
        mUpdateOwner(){
            if(this.mValidateDescriptionChange()){
                let message = {
                    title: 'Cambio de Propietario',
                    body: `¿Desea Registrar el cambio de Propietario de la Embarcacion con Matricula <b>${this.ship_select.enrollment_old}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.modal_load_id);
                            try {                                
                                let nprop={
                                    id_person:this.person_select.id,
                                    ship:this.ship_select.id,
                                    detail_transfer:this.description_transfer
                                }

                                // setTimeout(()=>{
                                //     console.log('termino de registrar')
                                //     this.mCloseModalUP(this.modal_load_id);
                                // }, 3000)
                                // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                                let regOwner= await axios.post(`transferOwner?api_token=${Vue.auth.getToken()}`, qs.stringify(nprop));
                                    
                                if(regOwner.data[0].status){
                                    toastr.success(regOwner.data[0].respuesta, 'Exito');
                                    this.mCloseSelectPerson();
                                    this.mCloseSelectShip();
                                    setTimeout(()=>{
                                        this.mCloseModalUP(this.modal_load_id);
                                        this.list_ship_select=[];
                                        this.data_ship=null;
                                    }, 3000) 
                                    
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.modal_load_id);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01')
            }
            console.log('enviando al servidor')
        },
        mViewSearchShip(event){
            // console.log(event);
            let radios=$("input[type=radio]").parent('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            // console.log(radioV);
            this.optionSearchShip=radioV;
        },
        mViewSearchPerson(event){
            console.log(event);
            let radios=$("input[type=radio]").parents('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            console.log(radioV);
            this.optionSearchPerson=radioV;
        },
        mCloseSelectPerson(){
            this.person_select.id=0;
            this.person_select.type_identification=0;
            this.person_select.number_identification=0;
            this.person_select.site_expedition=0;
            this.person_select.name=null;
            this.person_select.direction=null;
            this.person_select.mobile=null;
            this.person_select.phone=null;
            this.person_select.partner=null;
            this.person_select.nationality=0;
        },
        mSelectPersonOwner(sp){
            this.person_select.id=sp.id_propietario;
            this.person_select.type_identification=sp.tipo_identificacion;
            this.person_select.number_identification=sp.dato_identificacion;
            this.person_select.site_expedition=sp.id_expedido;
            this.person_select.name=sp.nombre_propietario;
            this.person_select.direction=sp.domicilio;
            this.person_select.mobile=sp.celular;
            this.person_select.phone=sp.telefono_fijo;
            this.person_select.partner=sp.representante_legal;
            this.person_select.nationality=sp.id_nacionalidad;
            // this.mChangeOwnerIdentificationEdit();
        },
        buscaDataPerson(){
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_person !== null || this.data_person.trim().length > 0 ){
                console.log('enviando al servidor');
                axios.get(`searchOwnerType/${this.data_person}/${this.optionSearchPerson}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {                    
                        this.list_person_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        buscaDataShip(){
            this.list_ship_select=[];
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_ship !== null || this.data_ship.trim().length > 0 ){
                // console.log('enviando al servidor');
                axios.get(`searchNameBoat/${this.optionSearchShip}/${this.data_ship}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {                    
                        this.list_ship_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mCloseSelectShip(){
            this.ship_select.id=0;
            this.ship_select.name_boat=null;
            this.ship_select.enrollment=null;
            this.ship_select.enrollment_old=null;
            this.ship_select.trb=null;
            this.ship_select.trn=null;
            // this.old_owner.id=0;
            // this.old_owner.name=null;
            // this.old_owner.documento=null;
            this.ship_select.import=0;
            this.pasavant_data.date_init_aux=null,
            this.pasavant_data.date_end_aux=null,
            this.pasavant_data.flag=0,
            this.pasavant_data.jurisdiccion=null,
            this.pasavant_data.number_office=null,
            this.pasavant_data.number_person=0,
            this.pasavant_data.person_responsability=null
        },
        mSelectShipOwner(sbp){
            this.ship_select.id=sbp.id_boat;
            this.ship_select.name_boat=sbp.name_boat;
            this.ship_select.enrollment=sbp.enrollment;
            this.ship_select.enrollment_old=sbp.enrollment_old;
            this.ship_select.trb=sbp.trb;
            this.ship_select.trn=sbp.trn;
            this.old_owner.id=sbp.id_propietario;
            this.old_owner.name=sbp.nombre_propietario;
            this.old_owner.documento=sbp.dato_identificacion;
            let result_temp=0;
            if(sbp.trn > 300){
                result_temp=this.ufv*300;
            }
            if(sbp.trn <= 300 && sbp.trn > 50){
                result_temp=this.ufv*100;
            }
            if(sbp.trn > 0 && sbp.trn <= 50){
                result_temp=this.ufv*50;
            }

            let aux_result=result_temp.toFixed(2);
                
            let number_enter=Math.trunc(aux_result);
            let number_decimal=Number((aux_result-number_enter).toFixed(2));
            let result=0;
            if(number_decimal===0.50){
                result=aux_result;
            }else if(number_decimal>0.50){
                result=number_enter+1;
            }else{                
                result=number_enter;             
            }
            this.ship_select.import=result;
            // this.mChangeOwnerIdentificationEdit();
        },
        buscaDataShipOficial(){
            // aqui buscamos para solicitud oficial
            this.list_ship_oficial=[];
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_ship_oficial !== null || this.data_ship_oficial.trim().length > 0 ){
                // console.log('enviando al servidor');
                axios.get(`searchNameBoatPasavant/${this.optionSearchShip}/${this.data_ship_oficial}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {              
                        console.log(this.list_ship_oficial);      
                        this.list_ship_oficial = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mCloseSelectShipOficial(){
            this.ship_select_oficial=[];
        },
        async mSelectShipOwnerOficial(sbp){
            // aqui seleccionamos a la embarcacion oficial y pasar al store para su solicitud oficial
            // console.log(sbp);
            // aqui armamos los datos antes de subirlo al store y cambiar de pantalla para su solicitud formal
            this.ship_pasavant_tmp.id_ship=sbp.id_boat;
            this.ship_pasavant_tmp.name_ship=sbp.name_boat;
            this.ship_pasavant_tmp.flag=sbp.flag;
            this.ship_pasavant_tmp.material_head=sbp.material_head; //integer
            this.ship_pasavant_tmp.type_navigate=sbp.type_navigate; //integer
            this.ship_pasavant_tmp.type_ship=sbp.type_ship;
            this.ship_pasavant_tmp.d_type_propulsion=sbp.type_propulsion; //array llamar a los tipos 
            this.ship_pasavant_tmp.trb=sbp.trb;
            this.ship_pasavant_tmp.trn=sbp.trn;
            this.ship_pasavant_tmp.eslora=sbp.eslora;
            this.ship_pasavant_tmp.manga=sbp.manga;
            this.ship_pasavant_tmp.puntal=sbp.puntal;
            this.ship_pasavant_tmp.year_construction=sbp.year_construction;
            this.ship_pasavant_tmp.site_construction=sbp.site_construction;
            this.ship_pasavant_tmp.cost_construction=sbp.cost_construction;
            this.ship_pasavant_tmp.d_type_activity_ship=sbp.d_type_activity_ship;
            this.ship_pasavant_tmp.type_service=sbp.destiny_navigate; //array

            // aqui llamamos al motor y los arreglos respectivos de sus caracteristicas
            // let aux_propulsion = await axios.get(`submenus/4?api_token=${Vue.auth.getToken()}`);
            // console.log(aux_propulsion);
            // console.log(sbp.engine.length);
            if(sbp.engine.length > 0){
                this.ship_pasavant_engine.id_engine=sbp.engine[0].id_motor;
                this.ship_pasavant_engine.exists=true;
                this.ship_pasavant_engine.trademark=sbp.engine[0].marca;
                this.ship_pasavant_engine.model=sbp.engine[0].modelo;
                this.ship_pasavant_engine.rpm=sbp.engine[0].hp_rpm;
                this.ship_pasavant_engine.serie=sbp.engine[0].serie;
                this.ship_pasavant_engine.gasoline=sbp.engine[0].combustible;
                this.ship_pasavant_engine.velocity_max=sbp.engine[0].velocidad_max;
            }else{
                this.ship_pasavant_engine.id_engine=0;
                this.ship_pasavant_engine.exists=false;
            }
            // console.log(sbp.owner.length);
            if(sbp.owner.length > 0){

                this.ship_pasavant_owner.id_owner=sbp.owner[0].id_propietario;
                this.ship_pasavant_owner.type_identification=sbp.owner[0].tipo_identificacion;
                this.ship_pasavant_owner.number_identification=sbp.owner[0].dato_identificacion;
                this.ship_pasavant_owner.site_expedition=sbp.owner[0].expedido;
                this.ship_pasavant_owner.name=sbp.owner[0].nombre_propietario;
                this.ship_pasavant_owner.direction=sbp.owner[0].domicilio;
                this.ship_pasavant_owner.mobile=sbp.owner[0].celular;
                this.ship_pasavant_owner.phone=sbp.owner[0].telefono_fijo;
                this.ship_pasavant_owner.partner=sbp.owner[0].representante_legal;
                this.ship_pasavant_owner.nationality=sbp.owner[0].nacionalidad;
            }else{
                this.ship_pasavant_owner.id_owner=0;
            }

            // console.log(this.ship_pasavant_tmp);
            // console.log(this.ship_pasavant_engine);
            // console.log(this.ship_pasavant_owner);
            this.$store.dispatch('sPasavantOf/addShipPasavant', this.ship_pasavant_tmp);
            this.$store.dispatch('sPasavantOf/addOwnerPasavant', this.ship_pasavant_owner);
            this.$store.dispatch('sPasavantOf/addEnginePasavant', this.ship_pasavant_engine);

            this.$router.push('/dashboard/pasavant-enroll');


        }
    },
    components:{
        'modal-loading':modalLoading
    },
    computed:{
        c_ship_approved_pending(){
            return this.$store.getters['sShipEnrollmentP/getEnrollmentPendingShip'];
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        },
        searchTypeShip(){
            switch(this.optionSearchShip){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        searchTypePerson(){
            switch(this.optionSearchPerson){
                case 'name':
                    return 'Nombre de la Persona';
                break;

                case 'document':
                    return 'Cedula de la Persona';
                break;
            }
        }
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>
    .required-text{
        color:red; 
        font-weight:bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/matriculacion/PasavanteOptions.vue